import styles from './GameBoard.module.css';

export interface GameBoardProps {
  board: (string | null)[];
  onCellClick: (cell: number) => void;
  isMyTurn: boolean;
  winningCells?: number[];
  disabled?: boolean;
}

function getAvatarSrc(name: string): string {
  // Public avatar files are lowercase-hyphenated, served from /avatars/
  const file = name.toLowerCase().replace(/\s+/g, '-');
  return `/avatars/${file}.svg`;
}

export function GameBoard({
  board,
  onCellClick,
  isMyTurn,
  winningCells = [],
  disabled = false,
}: GameBoardProps) {
  const isCellInteractive = (index: number): boolean => {
    return isMyTurn && !disabled && board[index] === null;
  };

  return (
    <div className={styles.container}>
      <div className={styles.grid} role="grid" aria-label="Tic-tac-toe game board">
        {board.map((cell, index) => {
          const isWinning = winningCells.includes(index);
          const interactive = isCellInteractive(index);
          const isOccupied = cell !== null;

          const cellClasses = [
            styles.cell,
            !interactive ? styles.disabled : '',
            isOccupied ? styles.occupied : '',
            isWinning ? styles.winning : '',
          ]
            .filter(Boolean)
            .join(' ');

          return (
            <button
              key={index}
              type="button"
              className={cellClasses}
              onClick={() => interactive && onCellClick(index)}
              disabled={!interactive}
              role="gridcell"
              aria-label={
                isOccupied
                  ? `Cell ${index + 1}: ${cell}`
                  : `Cell ${index + 1}: empty`
              }
              aria-disabled={!interactive}
              data-cell={index}
            >
              {isOccupied && (
                <img
                  src={getAvatarSrc(cell)}
                  alt={cell}
                  className={styles.avatarImg}
                />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
